// extracted by mini-css-extract-plugin
module.exports = {"EarningsPerShare":"EarningsPerShare_EarningsPerShare__YayGH","overview-page":"EarningsPerShare_overview-page__2muBs"};